<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="modal-title d-flex gap-2">
          <ng-container i18n>Discount Code</ng-container> <app-page-help articleId="-" videoId="-"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <button type="button" class="btn btn-secondary-info" [disabled]="1 | isReadonlyRole" (click)="onSave()">
          <span class="cs-icon cs-icon-save" aria-hidden="true"></span> <ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav top-navbar bg-white border-bottom" role="tablist">
      <li [class.active]="activeTab === tabs.DiscountCode">
        <a (click)="activeTab = tabs.DiscountCode" i18n> Details </a>
      </li>
      <li *ngIf="data.item?.id" [class.active]="activeTab === tabs.Activities">
        <a (click)="activeTab = tabs.Activities" i18n> Activity </a>
      </li>
      <li *ngIf="data.item?.id" [class.active]="activeTab === tabs.Logs">
        <a (click)="activeTab = tabs.Logs" i18n> Logs </a>
      </li>
    </ul>
    <div class="modal-body p-3 bg-none">
      <app-discount-code-detail
        #details
        [item]="data.item"
        *ngIf="activeTab === tabs.DiscountCode"
      ></app-discount-code-detail>
      <app-discount-code-bookings [item]="data.item" *ngIf="activeTab === tabs.Activities"></app-discount-code-bookings>

      <app-discount-code-logs [item]="data.item" *ngIf="activeTab === tabs.Logs"></app-discount-code-logs>
    </div>
  </div>
</div>
